import React from 'react';
import { Star, Clock } from 'lucide-react';
import { SectionHeader } from '../ui/Shared';
export function TestimonialsSection() {
  return <section id="testimonios" className="py-24 bg-surface" data-id="element-325">
      <div className="max-w-[780px] mx-auto px-6" data-id="element-326">
        <SectionHeader tag="Prueba real" title={<>
              Lo que cambia en
              <br data-id="element-328" />
              <span className="text-accent" data-id="element-329">solo 7 días</span>
            </>} data-id="element-327" />

        <div className="fade-up bg-gradient-to-br from-secondary to-[#0F1A2E] border border-accent/20 rounded-2xl p-8 md:p-12 mt-12 text-center relative overflow-hidden" data-id="element-330">
          <div className="absolute top-0 right-0 w-64 h-64 bg-[radial-gradient(circle,rgba(232,160,32,0.08),transparent)] rounded-full translate-x-1/2 -translate-y-1/2" data-id="element-331" />

          <div className="w-16 h-16 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-6 border border-accent/20" data-id="element-332">
            <Clock className="w-8 h-8 text-accent" data-id="element-333" />
          </div>

          <p className="text-xl md:text-2xl text-text-light font-playfair leading-relaxed relative z-10 italic" data-id="element-334">
            "Al finalizar la primera semana siguiendo el protocolo de
            hidratación y el descarte de gatillos, notarás que la presión en el
            pecho desaparece, tu voz recupera su tono natural y, por primera vez
            en años, podrás dormir 8 horas seguidas sin despertarte por el fuego
            en tu garganta."
          </p>

          <div className="flex justify-center gap-1 mt-8 text-accent" data-id="element-335">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-336" />)}
          </div>
        </div>
      </div>
    </section>;
}